import React from "react";
import "./ExclusiveServices.scss";
import images from "../../constants/images";
import { useNavigate } from "react-router-dom";



const services = [
  {
    title: "Architectural Design ",
    image: images.exclusive_service_img1,
    points: [
      "Creative, functional designs tailored to your vision",
      "Structural integrity with aesthetic harmony",
      "Clear, buildable plans from concept to completion",
    ],
  },
  {
    title: "Interior Design",
    image: images.exclusive_service_img2,
    points: [
      "Personalized spaces that reflect your style",
      "Curated selection of materials, colors, and furnishings",
      "Harmonious balance of beauty and comfort",
    ],
  },
  {
    title: "3D Modeling & Rendering",
    image: images.exclusive_service_img3,
    points: [
      "Realistic visualizations before construction begins",
      "Easy-to-understand previews of layouts and finishes",
      "Confident decision-making through clear visuals",
    ],
  },
  {
    title: "Revit (BIM)",
    image: images.exclusive_service_img4,
    points: [
      "Precise, coordinated architectural models",
      "Improved project collaboration and accuracy",
      "Streamlined documentation for construction and beyond",
    ],
  },
];

const ExclusiveServices = () => {
  const navigate = useNavigate();
  return (
    <>
    <section className="services">
      <div className="service_heading">
        <div className="heading_right">Exclusive Services</div>
        <div className="heading_left">
          <div className="vertical-line"></div>
          <p>Transforming your vision into<br/> a perfectly crafted reality.</p>
          </div>
      </div>
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.image} alt={service.title} />

            {/* ALWAYS VISIBLE TITLE */}
            <h3 className="card-title">{service.title}</h3>

            {/* HOVER CONTENT */}
            <div className="overlay">
              {service.points && (
                <ul>
                  {service.points.map((p, i) => (
                    <li key={i}>✓ {p}</li>
                  ))}
                </ul>
              )}

              <button type="button"   className="arrow-btn" onClick={() => {
  console.log("arrow clicked");
  navigate("/services");
}}
>→</button>
            </div>
          </div>
        ))}
      </div>
    </section>
    </>
  );
};

export default ExclusiveServices;
